import {
  InvalidateOptions,
  InvalidateQueryFilters,
  useQueryClient,
} from "@tanstack/react-query"
import type * as Api from "../../@client/api"

export function useInvalidate(
  queryFilters?: InvalidateQueryFilters,
  options?: InvalidateOptions
) {
  const client = useQueryClient()
  function invalidate<URL extends keyof Api.GET>(
    url: URL,
    input?: Partial<Api.Input[URL]>
  ) {
    const key = input ? [url, input] : [url]
    client.invalidateQueries({ queryKey: key, ...queryFilters }, options)
  }
  return invalidate
}
